import {
  GET_STORED_LANGUAGE_REQUEST,
  GET_STORED_LANGUAGE_SUCCESS,
  GET_STORED_LANGUAGE_FAILURE,

  SET_STORED_LANGUAGE_REQUEST,
  SET_STORED_LANGUAGE_SUCCESS,
  SET_STORED_LANGUAGE_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: false,
  isStoring: false,
  code: '',
  error: false
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case GET_STORED_LANGUAGE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false
      };
    case GET_STORED_LANGUAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        code: action.code
      };
    case GET_STORED_LANGUAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        code: '',
        error: action.error
      };
    case SET_STORED_LANGUAGE_REQUEST:
      return {
        ...state,
        isStoring: true,
        error: false
      };
    case SET_STORED_LANGUAGE_SUCCESS:
      return {
        ...state,
        isStoring: false,
        code: action.code
      };
    case SET_STORED_LANGUAGE_FAILURE:
      return {
        ...state,
        isStoring: false,
        code: '',
        error: action.error
      };
    default:
      return state;
  }
}
